'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { themeEditor } from 'ContentUtils/Routes';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
import { setActiveThemeFolderId } from 'DesignData/actions/finder/Themes';
import { setActiveProjectFolderId } from 'DesignData/actions/finder/Projects';
import { getActiveThemeFolderId, makeGetAssetParentProjectFolderId, makeGetFolderPath } from 'DesignData/selectors/finder';
import Bar from 'DesignFinderUI/components/commandbar/Bar';
import RootFolderNav from 'DesignFinderUI/components/nav/RootFolderNav';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';

function makeMapStateToProps() {
  const getFolderPath = makeGetFolderPath();
  const getAssetParentProjectFolderId = makeGetAssetParentProjectFolderId();
  return (state, props) => {
    const activeThemeFolderId = getActiveThemeFolderId(state);
    const parentProjectFolderId = getAssetParentProjectFolderId(state, {
      assetId: activeThemeFolderId
    });
    let path = null;

    if (activeThemeFolderId) {
      props = Object.assign({}, props, {
        assetId: activeThemeFolderId,
        folderId: activeThemeFolderId
      });
      path = (getFolderPath(state, props) || []).join('/');
    }

    return {
      activeThemeFolderId,
      parentProjectFolderId,
      path
    };
  };
}

const mapDispatchToProps = {
  setActiveThemeFolderId,
  setActiveProjectFolderId
};

class ThemeCommandBar extends Component {
  constructor(...args) {
    super(...args);

    this.onBackButtonClick = () => {
      const {
        parentProjectFolderId
      } = this.props;
      this.props.setActiveThemeFolderId(null);

      if (parentProjectFolderId) {
        this.props.setActiveProjectFolderId(parentProjectFolderId);
      }
    };

    this.trackThemeEditorPreviewClick = () => {
      const {
        usageTracker
      } = this.props;

      if (usageTracker) {
        usageTracker.track('preview', {
          action: 'open-editor',
          'asset-type': 'theme'
        });
      }
    };
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.activeThemeFolderId !== this.props.activeThemeFolderId) {
      return true;
    }

    if (nextProps.activeThemeFolderId && nextProps.path !== this.props.path) {
      return true;
    }

    return false;
  }

  renderBackButton() {
    const {
      parentProjectFolderId
    } = this.props;
    return /*#__PURE__*/_jsx(UIBackButton, {
      size: "xs",
      children: /*#__PURE__*/_jsx(UILink, {
        onClick: this.onBackButtonClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: parentProjectFolderId ? 'DesignFinderUI.breadcrumbs.backToProject.text' : 'DesignFinderUI.breadcrumbs.backToAll.text'
        })
      })
    });
  }

  renderThemePreviewLink() {
    const {
      path
    } = this.props;
    return /*#__PURE__*/_jsx(UIButton, {
      external: true,
      href: themeEditor(path, {
        testmode: true
      }),
      onClick: this.trackThemeEditorPreviewClick,
      use: "tertiary-light",
      size: "xs",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "DesignFinderUI.preview.text"
      })
    });
  }

  render() {
    if (!this.props.activeThemeFolderId) {
      return null;
    }

    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(Bar, {
        left: this.renderBackButton(),
        right: this.renderThemePreviewLink()
      }), /*#__PURE__*/_jsx(RootFolderNav, Object.assign({}, this.props, {
        type: "command-bar",
        rootFolderId: this.props.activeThemeFolderId,
        onUpdateCanDrop: this.props.onUpdateCanDrop,
        closeContextMenu: this.props.closeContextMenu,
        openContextMenu: this.props.openContextMenu
      }))]
    });
  }

}

ThemeCommandBar.propTypes = {
  activeThemeFolderId: FolderPropTypes.folderId,
  parentProjectFolderId: FolderPropTypes.folderId,
  path: PropTypes.string,
  setActiveThemeFolderId: PropTypes.func.isRequired,
  setActiveProjectFolderId: PropTypes.func.isRequired,
  onUpdateCanDrop: PropTypes.func.isRequired,
  closeContextMenu: PropTypes.func.isRequired,
  openContextMenu: PropTypes.func.isRequired,
  usageTracker: PropTypes.object
};
export default connect(makeMapStateToProps, mapDispatchToProps)(ThemeCommandBar);